import React, {useState, useEffect} from 'react';
import logo from '../../assets/img/site-logo.png'

export const BigLoading = (props) => {
  const [seconds, setSeconds] = useState(35);

  useEffect(() => {
    let interval = null;

    interval = setInterval(() => {
      setSeconds(seconds => seconds - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [seconds]);

  return (
    <div className='bigLoading-container'>
      {props.img ? <img src={logo} alt=""/> : null}
      <div className="big-spinner">
        <div className='countDown-container'>
          {seconds <= 30 && seconds > 0 ? seconds : ''}
        </div>
      </div>
    </div>
  );
}

